<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="blue darken-3"
    dark
    dense
    style="z-index: 11;"
  >
    <v-btn
      class="mx-2"
      fab
      icon
      x-small
      @click.stop="$store.commit('toggleDrawer')"
    >
      <v-icon dark> mdi-menu </v-icon>
    </v-btn>
    <v-spacer></v-spacer>

<v-text-field
  v-if="$store.state.searched"
            v-model="$store.state.search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
<v-spacer></v-spacer>
    
    <!-- Dropdown de Tema -->
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" class="mx-2">
          <v-icon>{{ $vuetify.theme.dark ? 'mdi-weather-night' : 'mdi-white-balance-sunny' }}</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="setTheme('light')">
          <v-list-item-icon>
            <v-icon>mdi-white-balance-sunny</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Tema Claro</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setTheme('dark')">
          <v-list-item-icon>
            <v-icon>mdi-weather-night</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Tema Escuro</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <span color="primary" dark v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </span>
      </template>

      <v-list flat>
        <v-subheader>{{$store.state.user.email}}</v-subheader>
        <v-list-item-group v-model="model" color="blue">
          <v-list-item :to="item.path" v-for="(item, i) in userMenus" :key="i">
            <v-list-item-icon>
              <v-icon :color="item.color" dense>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :style="{ color: item.color }">{{
                item.name
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    model: 1,
    userMenus: [
      { icon: "mdi-pencil-outline", name: "Editar", color: "", path: '/profiles' },
      { icon: "mdi-power", name: "Sair", color: "red", path: '/login' },
    ],
  }),
  methods: {
    setTheme(theme) {
      this.$vuetify.theme.dark = theme === 'dark';
      // Salvar preferência no localStorage
      localStorage.setItem('theme', theme);
    }
  },
  mounted() {
    // Carregar tema salvo no localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      this.$vuetify.theme.dark = savedTheme === 'dark';
    }
  }
};
</script>

<style scoped>
</style>